var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-alert',{class:_vm.color,attrs:{"border":"top","color":"red lighten-2","dark":""}},[_vm._v(" "+_vm._s(_vm.validationErrors)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }